import { post } from '@core/api/baseApi';
import { AssignRadiologistResponse } from '@core/types';

const assignRadiologist = async (studyInstanceUid: string, userUid: string): Promise<AssignRadiologistResponse> => 
    await post(`/Studies/${studyInstanceUid}/assign-radiologist/${userUid}`);

export default assignRadiologist;
